import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 保存
  mobileanyPhotosave(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhoto/save',
      method: 'post',
      data: data
    })
  },
  // 详情
  mobilesourceCheckgetById(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhoto/getById/' + id,
      method: 'get'
    })
  },
  // 删除
  mobilesourceCheckremove(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhoto/remove/' + id,
      method: 'get'
    })
  },
  // 选择问题处理人
  mobileanyPhotoallocateUser(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhoto/allocateUser',
      method: 'post',
      data: data
    })
  },
  // 全部问题
  mobileanyPhotopageAll(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhoto/pageAll',
      method: 'get',
      params: params
    })
  },
  // 分配处理人
  mobileanyPhotopageAllocate(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhoto/pageAllocate',
      method: 'get',
      params: params
    })
  },
  // 我处理的
  mobileanyPhotopageDeal(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhoto/pageDeal',
      method: 'get',
      params: params
    })
  },
  // 我审核的
  mobileanyPhotopageCheck(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhoto/pageCheck',
      method: 'get',
      params: params
    })
  },
  // 我的提交列表
  mobileanyPhotopageCreate(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhoto/pageCreate',
      method: 'get',
      params: params
    })
  },
  // 通知我的
  mobileanyPhotopageNotice(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhoto/pageNotice',
      method: 'get',
      params: params
    })
  },
  // 处理问题
  mobileanyPhotoDealsaveDeal(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhotoHistory/saveDeal',
      method: 'post',
      data: data
    })
  },
  // 审核问题
  mobileanyPhotoDealsaveCheck(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAnyPhotoHistory/saveCheck',
      method: 'post',
      data: data
    })
  },

  mobileanyPage(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/inspectionPointRecord/page',
      method: 'post',
      data: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/photographmobile/index.js